import React from "react";
import { InfoText } from "../../../../components";
import { keyToTitle } from "../../../../utils";

const PersonalDetails = ({ currentApplicantPersonalDetails }) => {
  //console.log(currentApplicantPersonalDetails)
  let personalDetails = {
    "First Name": "David",
    "Middle Name": "--",
    "Last Name": "Mosure",
    Gender: "--",
    "Primary Email": "dmosure12@gmail.com",
    State: "OH-US",
    City: "Youngstown",
    Zipcode: "28451",
  };

  const normalizeApplicantDetails = (data) => {
  const result = {};

  Object.entries(data || {}).forEach(([key, value]) => {
    if (key.toLowerCase().includes("email") && typeof value === "object") {
      // only keep email
      result[key] = value.email || "-";
    } else if (value === "" || value === null || value === undefined) {
      result[key] = "-"; // replace empty values
    } else {
      result[key] = value;
    }
  });

  return result;
};
const normalized = normalizeApplicantDetails(currentApplicantPersonalDetails);
  return (
   <div className="grid grid-cols-3 gap-5 my-3">
  {Object.entries(normalized).map(([key, value]) => (
    <div className="mx-5 font-[500]" key={key}>
      <InfoText
        size="sm"
        title={keyToTitle(key)}
        value={value}
      />
    </div>
  ))}
</div>

  );
};

export default PersonalDetails;
